import { Offcanvas, Form } from "react-bootstrap";
import CustomButton from "../../components/CustomButton/CustomButton";
import { useEffect, useState } from "react";
import WebService from "../../utility/WebService";
import { toast } from "react-toastify";
import { UserInterface } from "./Customer";
import HelperService from "../../utility/HelperService";
import { useForm } from "react-hook-form";
import ChangePasswordBlade from "../Customer/CustomerchangePasswordBlade";
import { EyeFill, EyeSlashFill } from 'react-bootstrap-icons';
import Select from "react-dropdown-select";

interface PropData {
    show: boolean;
    handleClose: () => void;
    data: UserInterface | null;
}

interface Option {
    label: string;
    value: string;
}

type OrganizationObj = {
    _id: string;
    name: string;
    type?: string;
};


const EditCustomer = (props: PropData) => {
    const { register, handleSubmit, formState: { errors }, reset, setValue, } = useForm<UserInterface>();
    const [isLoading, setLoading] = useState(false);
    const [selectedUser, setSelectedUser] = useState<UserInterface | null>(null);
    const [showNewPassword, setShowNewPassword] = useState(false)
    const [isPasswordBladeOpen, setPasswordBladeOpen] = useState(false)
    const [bladeTitle, setBladeTitle] = useState("");
    const [passwordMode, setPasswordMode] = useState<"MANUAL" | "LINK">("MANUAL");

    const [organizationOptions, setOrganizationOptions] = useState<Option[]>([]);
    const [selectedOrganization, setSelectedOrganization] = useState<Option[]>([]);

    const USER_TYPE_OPTIONS: Option[] = [
        { label: "Company Manager", value: "company manager" },
        { label: "Team Member", value: "company member" },
    ]

    const [selectedUserType, setSelectedUserType] = useState<Option[]>([]);

    const isCompanyMember =
        selectedUserType.length &&
        selectedUserType[0].value === "company member";

    const EMPTY_FORM: Partial<UserInterface> = {
        fullName: "",
        username: "",
        email: "",
        phone: "",
        password: "",
    };

    const loadOrganizations = async () => {
        try {
            const res: any = await WebService.getAPI({
                action: "organizations/list-all", // already filtered ORGANIZATION type
            });

            setOrganizationOptions(
                res.data.map((org: any) => ({
                    label: org.name,
                    value: org._id,
                }))
            );
        } catch {
            toast.error("Failed to load organizations");
        }
    };

    useEffect(() => {
        if (!props.show) return;

        loadOrganizations();

        if (props.data) {
            setBladeTitle('Edit User')
            reset(props.data);

            if (props.data?.type) {
                let userTypeValue = props.data.type;

                // ✅ ORG-ADMIN ko Company Manager treat karo
                if (userTypeValue === "ORG-ADMIN") {
                    userTypeValue = "company manager";
                }
                const matchedType = USER_TYPE_OPTIONS.find(
                    (opt) => opt.value === userTypeValue
                );

                if (matchedType) {
                    setSelectedUserType([matchedType]);
                } else {
                    setSelectedUserType([]);
                }
            } else {
                setSelectedUserType([]);
            }

            const org = props.data.organization;

            if (
                org &&
                typeof org === "object" &&
                "_id" in org &&
                (org as OrganizationObj).type === "ORGANIZATION"
            ) {
                const organization = org as OrganizationObj;

                setSelectedOrganization([
                    {
                        label: organization.name,
                        value: organization._id,
                    },
                ]);
            } else {
                setSelectedOrganization([]);
            }
        } else {
            setBladeTitle('Add User')
            reset(EMPTY_FORM);
            setSelectedUserType([]);
            setSelectedOrganization([]);
        }
    }, [props.show]);

    const onSubmit = async (data: any) => {
        setLoading(true);

        try {


            if (selectedOrganization.length && !selectedUserType.length) {
                toast.error("Please select user type");
                setLoading(false);
                return;
            }

            // const isCompanyMember =
            //     selectedUserType[0].value === "company member";

            // ✅ Organization mandatory for Company Member
            if (selectedUserType.length &&
                selectedUserType[0].value === "company member" &&
                !selectedOrganization.length) {
                toast.error("Please select organization for Company Member");
                setLoading(false);
                return;
            }

            console.log("???")
            const formData = new FormData();

            Object.keys(data).forEach((key) => {
                if (
                    data[key] !== undefined &&
                    data[key] !== null &&
                    key !== "organization" &&
                    key !== "type"
                ) {
                    formData.append(key, data[key]);
                }
            });

            // ✅ organization id (optional)
            if (selectedOrganization.length) {
                formData.append("organization", selectedOrganization[0].value);
            }

            // ✅ user type (required)
            if (selectedUserType.length) {
                formData.append("type", selectedUserType[0].value);
            }
            formData.append("password_mode", passwordMode);

            await WebService[props.data?._id ? "fileUploadPutAPI" : "fileUploadAPI"]({
                action: props.data?._id ? "users/update-user" : "users/add-user",
                body: formData,
                isFormData: true,
            });

            toast.success(
                props.data?._id
                    ? "User Updated Successfully"
                    : "User Created Successfully"
            );

            props.handleClose();
        } catch (err: any) {
            toast.error(err?.response?.data?.message || "Something went wrong");
        } finally {
            setLoading(false);
        }
    };


    const openPasswordBlade = () => {
        if (props.data) {
            setSelectedUser(props.data)
            onCloseModal()
            setPasswordBladeOpen(true)
        }
    }

    const onCloseModal = (e?: any) => {
        reset({})
        props.handleClose()
        setShowNewPassword(false)
    }


    return (
        <>
            <Offcanvas
                show={props.show}
                onHide={() => { reset(); props.handleClose(); }}
                placement="end"
                className="offcanvas-custom"
            >
                <Offcanvas.Header closeButton>
                    <Offcanvas.Title>{bladeTitle}</Offcanvas.Title>
                </Offcanvas.Header>

                <Offcanvas.Body>
                    <form onSubmit={handleSubmit(onSubmit)}>
                        <div className="mt-4 p-3 border rounded bg-light">
                            <h6 className="mb-3">Organization</h6>

                            <Form.Group className="mb-2">
                                <Form.Label>Select Organization</Form.Label>
                                <Select
                                    options={organizationOptions}
                                    values={selectedOrganization}
                                    onChange={setSelectedOrganization}
                                    labelField="label"
                                    valueField="value"
                                    searchable
                                    clearable
                                    placeholder="Search & select organization"
                                    disabled={!!props.data?._id}
                                />
                            </Form.Group>
                        </div>
                        <div className="mt-4 p-3 border rounded bg-light">
                            {/* <h6 className="mb-3">Primary Contact</h6> */}
                            {/* Name */}
                            <Form.Group className="mb-2">
                                <Form.Label>Name <span className="text-danger">*</span></Form.Label>
                                <Form.Control
                                    type="text"
                                    placeholder="Enter Name"
                                    {...register("fullName", { required: "Please enter name" })}
                                />
                                {errors.fullName && <div className="error-message">{errors.fullName.message}</div>}
                            </Form.Group>

                            {/* User Name */}
                            <Form.Group className="mb-2">
                                <Form.Label>User Name <span className="text-danger">*</span></Form.Label>
                                <Form.Control
                                    type="text"
                                    placeholder="Enter User Name"
                                    {...register("username", { required: "Please enter user name" })}
                                />
                                {errors.username && <div className="error-message">{errors.username.message}</div>}
                            </Form.Group>

                            {/* Mobile */}
                            <Form.Group className="mb-2">
                                <Form.Label>Mobile</Form.Label>
                                <Form.Control
                                    type="text"
                                    maxLength={10}
                                    placeholder="Enter Mobile"
                                    {...register("phone", {
                                        minLength: { value: 10, message: "Mobile number must be 10 digits" }
                                    })}
                                    onKeyPress={(e) => HelperService.allowOnlyNumericValue(e)}
                                />
                                {errors.phone && <div className="error-message">{errors.phone.message}</div>}
                            </Form.Group>

                            {selectedOrganization.length > 0 && (
                                <Form.Group className="mb-2">
                                    <Form.Label>User Group <span className="text-danger">*</span></Form.Label>
                                    <Select
                                        options={USER_TYPE_OPTIONS}
                                        values={selectedUserType}
                                        onChange={setSelectedUserType}
                                        labelField="label"
                                        valueField="value"
                                        clearable={false}
                                        searchable={false}
                                        placeholder="Select user type"
                                    />
                                </Form.Group>
                            )}

                            {/* Email */}
                            <Form.Group className="mb-2">
                                <Form.Label>Email <span className="text-danger">*</span></Form.Label>
                                <Form.Control
                                    type="text"
                                    placeholder="Enter Email"
                                    {...register("email", {
                                        required: "Please enter valid email",
                                        pattern: /^\S+@\S+$/i
                                    })}
                                />
                                {errors.email && <div className="error-message">Please enter valid email</div>}
                                {props.data?._id && (
                                    <div className="text-end mt-1">
                                        <a
                                            href="#"
                                            className="text-decoration-underline"
                                            style={{ whiteSpace: 'nowrap', fontSize: '0.85rem' }}
                                            onClick={(e) => {
                                                e.preventDefault()
                                                openPasswordBlade()
                                            }}
                                            data-user-id={props.data?._id}
                                        >
                                            Change Password
                                        </a>
                                    </div>
                                )}
                            </Form.Group>

                            {!props.data?._id && (
                                <Form.Group className="mb-3">
                                    <Form.Label>Password Setup</Form.Label>
                                    <Form.Select
                                        value={passwordMode}
                                        onChange={(e) =>
                                            setPasswordMode(e.target.value as "MANUAL" | "LINK")
                                        }
                                    >
                                        <option value="MANUAL">Set Password Manually</option>
                                        <option value="LINK">Send Password Setup Link</option>
                                    </Form.Select>
                                </Form.Group>
                            )}

                            {!props.data?._id && passwordMode === "MANUAL" && (
                                <>
                                    <Form.Label className="label">
                                        Password <span className="text-danger">*</span>
                                    </Form.Label>
                                    <div className="input-group">
                                        <span className="input-group-text bg-white border-end-0 text-secondary" style={{ height: "36px" }}>
                                            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                                <path d="m15.5 7.5 2.3 2.3a1 1 0 0 0 1.4 0l2.1-2.1a1 1 0 0 0 0-1.4l-2.3-2.3a1 1 0 0 0-1.4 0l-2.1 2.1a1 1 0 0 0 0 1.4Z" />
                                                <path d="m21 2-9.6 9.6" />
                                                <circle cx="7.5" cy="15.5" r="5.5" />
                                            </svg>
                                        </span>
                                        <input
                                            type={showNewPassword ? 'text' : 'password'}
                                            className="form-control ps-0 pe-2 border-0"
                                            placeholder="Enter Password"
                                            style={{
                                                height: "36px",
                                                boxShadow: "none",
                                                outline: "none",
                                                marginBottom: "unset",
                                                fontSize: "1rem"
                                            }}
                                            {...register('password', {
                                                required: 'Please enter password',
                                                minLength: {
                                                    value: 8,
                                                    message: 'Password must be at least 8 characters'
                                                },
                                                pattern: {
                                                    value: /^(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]).{8,}$/,
                                                    message: 'Password must contain one Uppercase letter, one Number, and one Special character'
                                                }
                                            })}
                                        />
                                        <span
                                            className="input-group-text text-secondary bg-white border-start-0 cursor-pointer"
                                            style={{ height: "36px" }}
                                            onClick={() => setShowNewPassword((prev) => !prev)}
                                        >
                                            {showNewPassword ? <EyeSlashFill size={16} /> : <EyeFill size={16} />}
                                        </span>
                                    </div>
                                    {errors.password && (
                                        <div className="error-message">{errors.password.message}</div>
                                    )}
                                </>
                            )}
                        </div>

                        {/* PASSWORD REMOVED ✔ */}

                        {/* SAVE BUTTON */}
                        <div className="d-flex justify-content-end p-3">
                            <CustomButton
                                isLoading={isLoading}
                                label="Save"
                                type="submit"
                                className="w-100"
                                id="saveCustomerButton"
                            />
                        </div>

                    </form>
                </Offcanvas.Body>
            </Offcanvas>
            {isPasswordBladeOpen && (
                <ChangePasswordBlade
                    isShow={isPasswordBladeOpen}
                    isClose={() => setPasswordBladeOpen(false)}
                    user={selectedUser}
                />
            )}
        </>

    );
};

export default EditCustomer;
